import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { widgetActions } from 'components/widget/widget.actions';
import { getMessengerWidgetTokenAndUrl } from './config';
class DixaMessenger extends PureComponent {
    componentDidMount() {
        const { messengerToken, loaderUrl } = getMessengerWidgetTokenAndUrl();
        this.injectDixaMessenger(loaderUrl);
        this.initializeDixaMessenger(messengerToken);
        // handleWidgetPresenceChange must be according to the
        // dixa messenger informing us of the events happening
        // in it. But for now since dixa messenger is still
        // not developed enough, we do it by hand. This is a "hack"
        this.handleWidgetPresenceChange({
            show_widget: true,
            show_contact_form: true,
        });
    }
    handleWidgetPresenceChange(presence) {
        this.props.setPresence(presence);
    }
    initializeDixaMessenger(messengerToken) {
        var _a;
        (_a = window === null || window === void 0 ? void 0 : window._dixa_) === null || _a === void 0 ? void 0 : _a.invoke('init', {
            messengerToken,
            hideToggler: true,
            showWidgetCloseButton: true,
            userIdentity: this.getAuthenticateData(),
        });
    }
    getAuthenticateData() {
        const { profile } = this.props;
        return {
            type: 'claim',
            name: profile.name || profile.display_name,
            email: profile.email,
        };
    }
    injectDixaMessenger(loaderUrl) {
        var _a;
        if (window._dixa_)
            return;
        // create a stub for the messenger to capture the commands
        // before the actual widget is loaded, so that they can be
        // executed afterwards.
        window._dixa_ = {
            pendingCalls: [],
            invoke: function (m, a) {
                var _a;
                // @ts-expect-error we are assigning value to `window._dixa_` property
                window._dixa_.pendingCalls = window._dixa_.pendingCalls || [];
                (_a = window._dixa_) === null || _a === void 0 ? void 0 : _a.pendingCalls.push([m, a]);
            },
            addListener: function (event, listener) {
                var _a, _b;
                // @ts-expect-error we are assigning value to `window._dixa_` property
                window._dixa_.pendingAddListenerCalls =
                    ((_a = window._dixa_) === null || _a === void 0 ? void 0 : _a.pendingAddListenerCalls) || [];
                (_b = window._dixa_) === null || _b === void 0 ? void 0 : _b.pendingAddListenerCalls.push([event, listener]);
            },
        };
        const scriptElement = document.createElement('script');
        scriptElement.type = 'text/javascript';
        scriptElement.setAttribute('charset', 'utf-8');
        scriptElement.async = true;
        scriptElement.src = loaderUrl;
        const firstScriptElement = document.getElementsByTagName('script')[0];
        if (firstScriptElement.parentNode) {
            (_a = firstScriptElement.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(scriptElement, firstScriptElement);
        }
        else {
            console.error('Failed to insert the dixa messenger to the document');
        }
    }
    render() {
        return null;
    }
}
const mapStateToProps = (state) => {
    return {
        profile: state.settings.profile.profile,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setPresence(presence) {
            dispatch(widgetActions.setPresence({ presence }));
        },
    };
};
export const DixaMessengerWidget = connect(mapStateToProps, mapDispatchToProps)(DixaMessenger);
